import { resolveApiBase } from "./apiBase";

const API_BASE = resolveApiBase();

export const ROLE_PERMISSIONS = {
    viewer: ["actions.view", "alerts.view", "policies.view", "rbac.view", "tenant.override_policy.view"],
    operator: ["actions.view", "actions.request", "actions.cancel_own", "terminal.connect", "terminal.observe", "alerts.view", "policies.view", "rbac.view", "tenant.override_policy.view"],
    approver: ["actions.view", "actions.approve", "actions.reject", "alerts.view", "policies.view", "rbac.view", "tenant.override_policy.view"],
    tenant_admin: [
        "actions.view",
        "actions.request",
        "actions.approve",
        "actions.reject",
        "actions.requeue",
        "actions.cancel",
        "actions.maintenance",
        "policies.view",
        "policies.edit",
        "policies.reset",
        "rbac.view",
        "rbac.manage",
        "tenant.config.view",
        "tenant.config.edit",
        "tenant.override_policy.view",
        "tenant.override_policy.edit",
        "agent_credentials.create",
        "agent_credentials.view",
        "agent_credentials.revoke",
        "agent_auth.view",
        "terminal.connect",
        "terminal.manage",
        "terminal.observe",
        "terminal.view_audit",
        "terminal.run_as",
        "alerts.view",
        "alerts.manage"
    ],
    platform_admin: ["*"]
};

export function getActor() {
    return localStorage.getItem("actor") || "admin-ui";
}

export function getRole() {
    return localStorage.getItem("role") || "viewer";
}

export function isPlatformAdminRole(role = getRole()) {
    return role === "platform_admin";
}

export function roleDisplayName(role = getRole()) {
    if (role === "platform_admin") return "Platform Admin";
    if (role === "tenant_admin") return "Tenant Admin";
    if (role === "approver") return "Approver";
    if (role === "operator") return "Operator";
    return "Viewer";
}

export function authHeaders(extra = {}) {
    const headers = {
        "X-Actor": getActor(),
        "X-Role": getRole(),
        ...extra
    };
    const token = localStorage.getItem("token");
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
}

export function permissionsForRole(role) {
    return ROLE_PERMISSIONS[role] || [];
}

export async function fetchTenantPermissions(tenantId) {
    const fallback = permissionsForRole(getRole());
    if (!tenantId) return fallback;

    try {
        const res = await fetch(`${API_BASE}/tenants/${tenantId}/rbac/me`, {
            headers: authHeaders(),
        });
        if (!res.ok) return fallback;
        const json = await res.json();
        return Array.isArray(json?.permissions) ? json.permissions : fallback;
    } catch {
        return fallback;
    }
}

export function hasPermission(permissions, permission) {
    if (!Array.isArray(permissions)) return false;
    return permissions.includes("*") || permissions.includes(permission);
}
